import script from "./pcTips.vue?vue&type=script&setup=true&lang=js"
export * from "./pcTips.vue?vue&type=script&setup=true&lang=js"

import "./pcTips.vue?vue&type=style&index=0&id=2bc2b92e&lang=less&scoped=true"

import exportComponent from "/data/home/csserver/project/cpcps/h5fe_cpcps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bc2b92e"]])

export default __exports__